import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

type BadgeOptions = {
  backgroundColor?: string
  color?: string | null
  image?: string | null
  title?: string | null
}

export default function Badge (props: BadgeOptions) {
  if (!props.image && !props.title) {
    return null
  }

  return (
    <span
      className={cn(styles.root)}
      style={{
        backgroundColor: props.backgroundColor,
        color: props.color as string,
      }}
    >
      {props.image && (
        <img
          className={styles.root__img}
          src={props.image}
          loading="lazy"
          fetchPriority="low"
          alt=""
        />
      )}

      {props.title}
    </span>
  )
}
